import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Port'],
});
export const portApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllPorts: builder.query({
      query: () => `ports/`,
      providesTags: ['Port'],
    }),
    findAllPortsWithLocation: builder.query({
      query: () => `ports/?location_master__isnull=False`,
      providesTags: ['Port'],
    }),
    findAllPortsOfCluster: builder.query({
      query: (id) => `ports/?cluster=${id}/`,
      providesTags: ['Port'],
    }),
    findPortById: builder.query({
      query: (id) => `ports/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Port', id: result.id }] : ['Port'];
      },
    }),
    createPort: builder.mutation({
      query: (port) => ({
        url: `ports/`,
        method: 'POST',
        body: port,
      }),
      invalidatesTags: ['Port'],
    }),
    updatePort: builder.mutation({
      query: (port) => ({
        url: `ports/${port.id}/`,
        method: 'PATCH',
        body: port,
      }),
      invalidatesTags: ['Port'],
    }),
    updatePortLocation: builder.mutation({
      query: ({ id, payload }) => ({
        url: `ports/${id}/insertLocation/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Port'],
    }),
    deletePort: builder.mutation({
      query: (port) => ({
        url: `ports/${port.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Port'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllPortsQuery,
  useFindAllPortsWithLocationQuery,
  useFindPortByIdQuery,
  useCreatePortMutation,
  useUpdatePortMutation,
  useDeletePortMutation,
} = portApi;
